import React from "react";
import { NavLink } from "react-router-dom";
import { Card, CardHeader, CardBody, Button, Spinner } from "reactstrap";
const CardLayout = ({ heading, navigationButton, printlable,Settled, isPrintinvoiceLoading,approve,reject, ReassignDriver, getduplicatecostsheet,OutForDelivered, navigationButton2, isPrintLabelLoading, link2, link, children, extra_comp, isAdmin, hideButton, showButton, printinvoice, handleClick, getinvioceButton, cancleButtton, Delivered, DeliveredDone, barcode, }) => {
    return (
        <Card>
            <CardHeader className="d-flex mobile_Css justify-content-between align-items-center">
                <h5 className="card-title mb-0">{heading}
                    {
                        extra_comp != undefined &&
                        <>
                            {
                                extra_comp
                            }
                        </>
                    }
                </h5>

                <div className="mobile_buttons">
                    {getinvioceButton && (
                        <>
                            {typeof getinvioceButton === 'function' ? (
                                <Button color="primary" outline className="btn-sm me-2" onClick={getinvioceButton}>
                                    Generate Invoice
                                </Button>
                            ) : (
                                <Button color="primary" outline className="btn-sm me-2">
                                    {getinvioceButton}
                                </Button>
                            )}
                        </>
                    )}
                    {getduplicatecostsheet && (
                        <>
                            {typeof getduplicatecostsheet === 'function' ? (
                                <Button color="primary" outline className="btn-sm me-2" onClick={getduplicatecostsheet}>
                                    Duplicate CostSheet
                                </Button>
                            ) : (
                                <Button color="primary" outline className="btn-sm me-2">
                                    {getduplicatecostsheet}
                                </Button>
                            )}
                        </>
                    )}
                    {ReassignDriver && (
                        <>
                            {typeof ReassignDriver === 'function' ? (
                                <Button color="primary" outline className="btn-sm me-2" onClick={ReassignDriver}>
                                    ReAssign Driver
                                </Button>
                            ) : (
                                <Button color="primary" outline className="btn-sm me-2">
                                    {ReassignDriver}
                                </Button>
                            )}
                        </>
                    )}
                    {Settled && (
                        <>
                            {typeof Settled === 'function' ? (
                                <Button color="primary" outline className="btn-sm me-2" onClick={Settled}>
                                    Settled
                                </Button>
                            ) : (
                                <Button color="primary" outline className="btn-sm me-2">
                                    {Settled}
                                </Button>
                            )}
                        </>
                    )}
                    {printinvoice && (
                        <>
                            {typeof printinvoice === "function" ? (
                                <Button
                                    color="primary"
                                    outline
                                    className="btn-sm me-2 "
                                    onClick={printinvoice}

                                >

                                    Print Invoice
                                    {isPrintinvoiceLoading &&
                                        <>
                                            <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"> Loading... </Spinner>

                                        </>
                                    }
                                </Button>
                            ) : (
                                <Button color="primary" outline className="btn-sm me-2">
                                    {printinvoice}
                                </Button>
                            )}
                        </>
                    )}
                               {approve && (
                        <>
                            {typeof approve === 'function' ? (
                                <Button color="primary" outline className="btn-sm me-2" onClick={approve}>
                                    Approve
                                </Button>
                            ) : (
                                <Button color="primary" outline className="btn-sm me-2">
                                    {approve}
                                </Button>
                            )}
                        </>
                    )}
                    {reject && (
                        <>
                            {typeof reject === 'function' ? (
                                <Button color="danger" outline className="btn-sm me-2" onClick={reject}>
                                    Reject
                                </Button>
                            ) : (
                                <Button color="danger" outline className="btn-sm me-2">
                                    {reject}
                                </Button>
                            )}
                        </>
                    )}
          
                    {Delivered && (
                        <>
                            {typeof Delivered === 'function' ? (
                                <Button color="primary" outline className="btn-sm me-2" onClick={Delivered}>
                                    Delivered
                                </Button>
                            ) : (
                                <Button color="primary" outline className="btn-sm me-2">
                                    {Delivered}
                                </Button>
                            )}
                        </>
                    )}

                    {DeliveredDone && (
                        <>
                            {typeof DeliveredDone === 'function' ? (
                                <Button color="primary" outline className="btn-sm me-2" onClick={DeliveredDone}>
                                    Deposit Amount
                                </Button>
                            ) : (
                                <Button color="primary" outline className="btn-sm me-2">
                                    {Done}
                                </Button>
                            )}
                        </>
                    )}
                    {OutForDelivered && (
                        <>
                            {typeof OutForDelivered === 'function' ? (
                                <Button color="primary" outline className="btn-sm me-2" onClick={OutForDelivered}>
                                    Out For Delivery
                                </Button>
                            ) : (
                                <Button color="primary" outline className="btn-sm me-2">
                                    {OutForDelivered}
                                </Button>
                            )}
                        </>
                    )}

                    {printlable && (
                        <>
                            {typeof printlable === "function" ? (
                                <Button
                                    color="primary"
                                    outline
                                    className="btn-sm me-2 "
                                    onClick={printlable}

                                >

                                    Print Label
                                    {isPrintLabelLoading &&
                                        <>
                                            <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"> Loading... </Spinner>

                                        </>
                                    }
                                </Button>
                            ) : (
                                <Button color="primary" outline className="btn-sm me-2">
                                    {printlable}
                                </Button>
                            )}
                        </>
                    )}

                    {cancleButtton && (
                        <>
                            {typeof cancleButtton === 'function' ? (
                                <Button color="danger" outline className="btn-sm me-2" onClick={cancleButtton}>
                                    Cancel
                                </Button>
                            ) : (
                                <Button color="danger" outline className="btn-sm me-2">
                                    {Cancel}
                                </Button>
                            )}
                        </>
                    )}

                    {
                        navigationButton2 != undefined &&
                        <NavLink to={link2} className={'me-2'}>
                            <Button color="primary" outline className="btn-sm">
                                {navigationButton2}
                            </Button>
                        </NavLink>
                    }

                    {
                        (navigationButton != undefined && isAdmin == undefined && hideButton == undefined) &&
                        <NavLink to={link} className={'navigation_btn'}>
                            <Button color="primary" outline className="btn-sm">
                                {navigationButton}
                            </Button>
                        </NavLink>
                    }

                    {
                        (navigationButton != undefined && !isAdmin && hideButton !== undefined) &&
                        <NavLink to={link} className={'navigation_btn'}>
                            <Button color="primary" outline className="btn-sm">
                                {navigationButton}
                            </Button>
                        </NavLink>
                    }

                </div>

                {
                    (showButton != undefined && isAdmin) &&
                    <div class="d-flex gap-1 flex-wrap">
                        <Button type="button" color="primary" outline className="btn-sm" onClick={() => handleClick('approve')}> Approve</Button>
                        <Button type="button" color="danger" outline onClick={() => handleClick('reject')}> Reject</Button>
                    </div>
                }

            </CardHeader>
            <CardBody>
                {children}
            </CardBody>

        </Card>
    )
}
export default CardLayout